import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

const AtualizarGuiaModal = ({ show, onHide, onConfirm, agenda }) => {
  const [guiaConsulta, setGuiaConsulta] = useState('');
  const [guiaEcg, setGuiaEcg] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setGuiaConsulta('');
      setGuiaEcg('');
      setIsSubmitting(false);
    }
  }, [show]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm({
        guiaConsulta: guiaConsulta.trim() !== '' ? guiaConsulta.trim() : null,
        guiaEcg: guiaEcg.trim() !== '' ? guiaEcg.trim() : null,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-success">
          Atualizar Guia Convênio
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Informe os números das guias para o paciente{' '}
          <strong>{agenda?.NOMEPAC}</strong>. Deixe o campo em branco caso não
          queira atualizar a guia respectiva.
        </p>

        <Form.Group>
          <Form.Label>
            <strong>GUIA - CONSULTA</strong>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Digite o número da guia de consulta"
            value={guiaConsulta}
            onChange={(e) => setGuiaConsulta(e.target.value)}
            disabled={isSubmitting}
            autoFocus
          />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>
            <strong>GUIA - ECG</strong>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Digite o número da guia de ECG"
            value={guiaEcg}
            onChange={(e) => setGuiaEcg(e.target.value)}
            disabled={isSubmitting}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={
            isSubmitting ||
            (guiaConsulta.trim() === '' && guiaEcg.trim() === '')
          }
        >
          {isSubmitting ? (
            <Spinner animation="border" size="sm" />
          ) : (
            'Atualizar Guias'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AtualizarGuiaModal;
